import i18n from "i18next";
import {initReactI18next} from 'react-i18next';
import common_en from './translations/en.json';
// import common_fr from './translations/fr.json';
import common_es from './translations/es.json';
import common_it from './translations/it.json';


const resources = {
    en: {
        translation : common_en
    },
    // fr: {
    //     translation : common_fr
    // },
    es: {
        translation : common_es
    },
    it: {
        translation : common_it
    }
}

i18n.use(initReactI18next)
.init({
    resources,
    lng: 'en',
    // Sin fallbackLng una clave que falte en un idioma se pinta cruda en
    // pantalla ("hire_now" en vez del texto). Con 'en' se degrada al ingles,
    // que es lo que la home ya ensenaba antes de traducirla.
    fallbackLng: 'en',
    keySeparator: false,
    interpolation: {
        escapeValue : false
    }
});

export default i18n;